// extracted by mini-css-extract-plugin
export default {"search-result-placeholder":"ZCxAIh","placeholder-animation":"U5J3MK","search-result-placeholder__item":"TspWQr"};